\]
<template>
  <div class="flex flex-col store-item">
    <div v-if="store.isBuyAddress===1" style="font-size:14px;color: #ed6c0f">{{$t('ProductInfo.DeviceOriginBuyAddress')}}</div>
    <div class="flex flex-row justify-between ">
      <span class="store-name">{{ store.name }}</span>
      <van-image :src="require('@/assets/ic_navigator.png')" width="20" height="20"
                 @click="onNavigateClick"/>

    </div>
    <div class="store-distance-detail">
      <span  v-if="store.distance" class="from">{{$t('ProductInfo.Distance')}} {{ distance }}</span> |
      {{ store.street }}
    </div>

    <div class="flex flex-row justify-between store-community">
      <span class="website" @click="onCallPhone">{{ store.phone }}</span>
      <span class="website" @click="onWebSiteClick">{{ store.website }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "WhereToBuyItem",
  props: {
    store: {
      type: Object
    }
  },
  computed: {
    distance() {
      return `${this.store.distance}${this.store.unit === 2 ? "km" : "m"}`
    }
  },
  methods: {
    onNavigateClick() {

      const url = `https://api.map.baidu.com/marker?location=${this.store.lat},${this.store.lng}&title=目的地&output=html&content=${this.store.street}`;
      // window.location.href = url;
      window.open(url)
    },
    onWebSiteClick() {
      if (this.store.website) {
        window.open(this.store.website)
      }
    },
    onCallPhone() {
      window.location.href = `tel:${this.store.phone}`;
    }
  }
}
</script>

<style scoped lang="less">
.store-item {
  background: #2D2D2D;
  padding: 16px;
}

.store-name {
  font-weight: bold;
  font-size: 18px;
}

.store-distance-detail {
  color: #999999;

  .from {
    color: white;
  }

  font-size: 12px;
}

.store-community {
  font-size: 12px;
  margin-top: 6px;

  .phone {
    color: #999999;
  }

  .website {
    color: #48BCFF;
  }
}
</style>